import { render, staticRenderFns } from "./WordReportInstructions.vue?vue&type=template&id=47bb8364&"
import script from "./WordReportInstructions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WordReportInstructions.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports